import React from 'react';

import { disabledColor } from '@zego/theme';

interface VerticalHairlineProps {
  color?: string;
  height?: string;
  className?: string;
  thickness?: string;
}

const VerticalHairline = ({
  color = disabledColor(4),
  height = 'auto',
  className,
  thickness = '1.1px',
}: VerticalHairlineProps): JSX.Element => (
  <div
    className={className}
    css={{
      height: `${height}`,
      borderLeft: `${thickness} solid ${color}`,
    }}
  />
);

export default VerticalHairline;
